import _ from 'lodash';
import { realtimeDocumentTypes } from "projectSpecific/sports/cnr/reducers/SportsEditMatchReducer";
import { realTimeScoring } from "projectSpecific/sports/dbActions/realtimeScoring";
import { useContext, useEffect, useMemo, useState } from "react";
import { DatabaseContext } from "../../../global/cnr/contexts/DatabaseContext";
import { ParentContext } from "../../../global/cnr/contexts/ParentContext";

export const _matchSeasonalCollection = 'matches_seasonal'

const _applyCache = false

export const useSportsRealtimeResults = ({ }) => {

  const parentContext = useContext(ParentContext)
  const { states, handlers, fns } = parentContext ?? {}
  const { app_state, appUser_state, paps_state, page_state, serviceWorker_state, currentSettings_state } = states ?? {}
  const { appUser_handlers, serviceWorker_handlers } = handlers ?? {}
  const { mainRt } = app_state

  const { view, pathViews } = paps_state ?? {}
  const { events: eventKey } = pathViews ?? {}

  const databaseContext = useContext(DatabaseContext);
  const { database_fns } = databaseContext ?? {};

  // pageContext 
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { sportPermissions } = aps_global ?? {}

  const { viewItems: viewItems_page } = aps_page ?? {}

  let viewItem = viewItems_page && viewItems_page[view] ? viewItems_page[view] : {}

  const { dataSource } = viewItem ?? {}
  const { dataParents, useSeasonals } = dataSource ?? {}

  const [realtimeResults, setRealtimeResults] = useState({})
  const [matchDayResults, setMatchDayResults] = useState({})

  // Guard to prevent multiple fetches
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    setInitialized(false);
  }, [eventKey]);

  useEffect(() => {
    if (!pathViews || !database_fns || initialized || !pathViews.events) return;

    setInitialized(true);

    (async () => {


      const handleSet_realtimeResults = (r) => {
        setRealtimeResults(r ? r : {})
      }

      const handleSet_realtimeMatchDateResults = (r) => {
        setMatchDayResults(r ? r : {})
      }

      try {
        if (1 === 1) {
          const latestSeason = 2026
          realTimeScoring.getRealtimeScores(mainRt, realtimeDocumentTypes.realtime, true, pathViews, latestSeason, handleSet_realtimeResults)
          realTimeScoring.getRealtimeScores(mainRt, realtimeDocumentTypes.matchDay, true, pathViews, latestSeason, handleSet_realtimeMatchDateResults)
        }
      } catch (err) {
        console.error(`❌ Failed to fetch event data`, err);
      }
    })();
  }, []);

  // ------------------- Memoized stable return -------------------
  const sportsRealtimeResultsInfo = useMemo(
    () => ({ realtimeResults, matchDayResults }),
    [realtimeResults, matchDayResults]
  );

  return sportsRealtimeResultsInfo;

}; 